
export namespace Enums {
    export enum RouteType {
        FromDestination = 0,
        ToDestination = 1,
        ViaDestination = 2,
        FromCurrentLocation = 3,
        ToCurrentLocation = 4
    }
}

export enum RouteParams {
    fromRoute,
    toRoute
}

export enum DISTANCE_TYPE {
    KM = 'km',
    MILES = 'miles'
  }

export enum SIGNPOST_SIGN {
    MOTORWAY_SIGN = 1,
    PRIMARY_ROAD_SIGN = 2,
    LOCAL_ROAD_SIGN = 3,
    PLACE_OF_INTEREST_SIGN = 4,
    AA_SIGN = 5,
    RAF_BASE_SIGN = 6,
    HOSPITAL_SIGN = 7
}

export enum BENEFIT_OFFERS_TYPE {
    MB = 'M&B'
}
